import { AppState } from '../configureStore';

export const selectState = (state: AppState) => state.changeLogProject;
